/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isInt } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Grid, Autocomplete } from '@mui/material';
import TextMaskCustomCpf from '../../utils/TextMaskCustomCpf';
import axios from '../../services/axios';
import { Container, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [nome, setNome] = useState('');
  const [sobrenome, setSobrenome] = useState('');
  const [cpf, setCpf] = useState('');
  const [id_empresa, setIdEmpresa] = useState('');
  const [id_user, setIdUser] = useState('');
  const [tableDataEmpresa, setTableDataEmpresa] = useState([]);
  const [tableDataUser, setTableDataUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const textData = 'Funcionário';
  // const tableData = 'cliente';
  const tableDatas = 'funcionarios';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id}`);
      setNome(data.nome);
      setSobrenome(data.sobrenome);
      setCpf(data.cpf);
      setIdEmpresa(data.id_empresa);
      setIdUser(data.id_user);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      let responsekey = await axios.get('/empresas');
      setTableDataEmpresa(responsekey.data);
      responsekey = await axios.get('/users');
      setTableDataUser(responsekey.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  useEffect(() => {
    async function fetchData() {
      await getDataDropdown();

      if (id) {
        // se for alteração
        await getData();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    if (nome.length < 3 || nome.length > 255) {
      toast.error('Nome precisa ter entre 3 e 255 caracteres');
      formErrors = true;
    }

    if (sobrenome.length < 3 || sobrenome.length > 255) {
      toast.error('Sobrenome precisa ter entre 3 e 255 caracteres');
      formErrors = true;
    }

    const newCPF = cpf.replace(/[^0-9]/g, '');
    if (!cpfValidator.isValid(newCPF)) {
      toast.error(`CPF inválido.`);
      formErrors = true;
    }
    setCpf(newCPF);

    if (!isInt(String(id_empresa))) {
      toast.error('Id da Empresa inválida');
      formErrors = true;
    }

    if (!isInt(String(id_user))) {
      toast.error('Id do Usuário inválida');
      formErrors = true;
    }

    if (formErrors) return;

    try {
      setIsLoading(true);

      if (id) {
        await axios.put(`/${tableDatas}/${id}`, {
          nome,
          sobrenome,
          cpf: newCPF,
          id_empresa,
          id_user,
        });
        toast.success(`Alterado com sucesso!`);
        navigate(`/${tableDatas}/`);
      } else {
        await axios.post(`/${tableDatas}/`, {
          nome,
          sobrenome,
          cpf: newCPF,
          id_empresa,
          id_user,
        });
        toast.success(`Cadastrado com sucesso!`);
        navigate(`/${tableDatas}/`);
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Title>{id ? `Alterar ${textData}` : `Novo ${textData}`}</Title>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={nome}
              label="Nome"
              onChange={(e) => setNome(e.target.value)}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              value={sobrenome}
              label="Sobrenome"
              size="small"
              onChange={(e) => setSobrenome(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              required
              label="CPF"
              size="small"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              InputProps={{
                inputComponent: TextMaskCustomCpf,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_empresa}
              value={
                tableDataEmpresa.find((option) => option.id === id_empresa) ||
                null
              }
              options={tableDataEmpresa}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_user}
              value={
                tableDataUser.find((option) => option.id === id_user) || null
              }
              options={tableDataUser}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdUser(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Usuário"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button type="button" onClick={() => navigate(`/${tableDatas}`)}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
